export const paths = {
  'Home': '/',
  'CheckingPage': '/binning/chequeo',
  'StoragePage': '/binning/guardado',
  'BinningClose': '/binning/cierre',
  'BinningChecking': '/binning/chequeo/:invoice',
  'BinningStorage': '/binning/guardado',
  'BinningVerifyInvoice': '/binning/chequeo/:invoice/verificar',
  'BinningLabelsReprint': '/facturas/reimprimir-etiquetas',
  'PartsQueryList': '/partes/consultas',
  'ViewCpdQuery': '/partes/consultas/ver/:code',
  'Kardex': '/partes/kardex',
  'ViewKardex': '/partes/consultas/ver/:code/kardex/:warehouse',
  'BackOrdersReport': '/reportes/back-orders',
  'PartsAnalysisList': '/partes/analisis',
  'EditPartsAnalysis': '/partes/analisis/editar/:code',
  'PartsSalesList': '/partes/ventas',
  'IccMatrix': '/matriz',
  'ProvidersList': '/proveedores',
  'EditProvider': '/proveedores/editar/:code',
  'SeeEditProvider': '/proveedores/ver/:code',
  'OriginsList': '/origenes',
  'EditOriginNew': '/origenes/nuevo',
  'EditOrigin': '/origenes/editar/:code',
  'InvoiceLoad': '/carga/factura/proveedor',
  'EditInvoiceLoad': '/carga/factura/:invoice/proveedor/:providerId',
  'InvoiceQuery': '/consulta/factura',
  'IccParameters': '/matriz/parametros',
  'MadParameters': '/matriz/parametros/mad',
  'AccessDenied': '/accesodenegado',
  'PickingDashboard': '/picking/dashboard',
  'WarehouseDenialCausesList': '/picking/warehouse-denied',
  'EditWarehouseDenialCause': '/picking/warehouse-denied/editar/:code',
  'NewWarehouseDenialCause': '/picking/warehouse-denied/nuevo',
  'ShiftsList': '/picking/cortes',
  'EditShift': '/picking/cortes/editar/:code',
  'NewShift': '/picking/cortes/nuevo',
  'ZonesList': '/picking/zonas',
  'EditZone': '/picking/zonas/editar/:code',
  'NewZone': '/picking/zonas/nuevo',
  'Scanning': '/picking/escaneo',
  'StoragePendingCars': '/picking/coches-abiertos',
  'ScanningWarehouseDenied': '/picking/escaneo/warehouse-denied',
  'ManualsOrdersList': '/picking/pedidos-manuales',
  'ManualsOrderDetailManager':
    '/picking/pedidos-manuales/editar/concesionario/:dealerId/agencia/:agencyId/order/:order',
  'WarehouseTransfer': '/transferencias',
  'InternalOrdersList': '/pedidos-internos',
  'InternalOrderCreate': '/pedidos-internos/nuevo',
  'InternalOrderEdit': '/pedidos-internos/editar/:orderCode',
  'Invoicing': '/pedidos/facturacion/:client?/:warehouse?',
  'ManualInvoicing': '/pedidos/facturacion',
  'SalesKpi': '/kpi/ventas',
  'SalesAndBudgetsLoad': '/carga/ventas-y-presupuestos',
  'PartWatchingList': '/kpi/part-watching',
  'PartWatchingKpi': '/kpi/part-watching/:code',
  'SetSales': '/venta-combos',
  'SetSalesDetail':
    '/venta-combo-detalle/:startDate/:endDate/:customerId/:setCode',
  'ReceivedAndDispatchedLinesKpi': '/kpi/lineas-recepcionadas-y-despachadas',
  'VehiclesKpi': '/kpi/autos',
  'VehiclesSalesDetail':
    '/kpi/autos/ventas/detalle/:startDate/:endDate/:dealerId/:modelName',
  'ParametersList': '/listado-parametros',
  'ParametersEdit': '/parametro/editar/:parameterCode',
  'ParametersNew': '/parametro/nuevo',
  'UsersList': '/listado-usuarios',
  'UsersRequestEdit': '/usuarios-solicitudes/editar/:code',
  'UsersRequestNew': '/usuarios-solicitudes/nuevo',
  'UsersEdit': '/usuarios/editar/:username',
  'UsersNew': '/usuarios/nuevo',
  'PartAudit': '/auditoria-partes',
  'LocationsUsageReport': '/ubicaciones-bodega/uso',
  'LocationsForm': '/ubicaciones-bodega/nuevo',
  'WarehouseLocationsList': '/ubicaciones-bodega',
  'LocationsAssignment': '/ubicaciones-bodega/asignacion',
  'MasterVehicleFormAdd': '/maestro-vehiculos/nuevo',
  'ManageColorsFormAdd': '/gestion-colores/nuevo',
  'VehiclesHistoryColor': '/mantenimiento-vehiculos/vehiculos-historial-colores',
  'MasterVehicleList': '/maestro-vehiculos/listado',
  'MasterVehUpdate': '/maestro-vehiculos/editar/:vehCode',
  'ComboTasks': '/accesorios/tareas/combos',
  'LogisticAreas': '/logistica/areas',
  'AccessoriesOrders': '/accesorios/pedidos',
  'AccessoriesOrdersPDS': '/accesorios/pedidos-pds',
  'QualityControlInvoicing': '/accesorios/control-calidad/facturacion',
  'QualityControlAccessoriesOrdersList': '/accesorios/pedidos-control-calidad',
  'QualityControlAccessoriesOrdersCreate':
    '/accesorios/pedidos-control-calidad/nuevo',
  'PartsAssignmentInQualityControlOrders':
    '/accesorios/pedidos-control-calidad/:orderNumber/asignar-partes',
  'TasksAssignmentInQualityControlOrders':
    '/accesorios/pedidos-control-calidad/:orderNumber/asignar-tareas',
  'PartNumberCodeQueryList': '/codigo-numero-parte',
  'AddPartNumberCode': '/codigo-numero-parte/nuevo',
  'FormsSearch': '/formularios/buscar',
  'FormsList': '/formularios',
  'NewForm': '/formulario/:formType/:id/:actionType',
  'NewFormResponse': '/formulario/:formType/:id/:actionType/:answerId',
  'FormTemplateOrFormResponse': '/formulario/:id/:actionType',
  'FormsSkrSearch': '/formularios/skr/buscar',
  'SkrFormTemplateCreate': '/formulario-skr/nuevo',
  'SkrFormTemplateOrResponse': '/formulario-skr/:actionType/:id',
  'EnteredAnswersList': '/formularios/ingresados',
  'EditPartNumberCode': '/codigo-numero-parte/editar/:code',
  'ClonePartNumberCode': '/codigo-numero-parte/clonar',
  'PartsCatalog': '/repuestos/jpml',
  'PriceFactorsMaintenance': '/factores-de-precio',
  'LiquidationsList': '/liquidaciones',
  'LiquidationsDetail': '/liquidaciones/detalle/:invoiceOrder',
  'PriceFactorsAdd': '/factores-de-precio/nuevo',
  'PriceFactorsEdit': '/factores-de-precio/editar',
  'PriceFactorsClone': '/factores-de-precio/clonar',
  'VehiclesEfficiency': '/kpi/autos/eficiencia',
  'ObsolescenceParams': '/parametros/obsolescencia',
  'SpecialParts': '/partes-especiales',
  'SpecialPartsAdd': '/partes-especiales/nuevo',
  'SpecialPartsEdit': '/partes-especiales/editar/:partno',
  'VehiclesObjectiveSales': '/vehiculos-objetivo-ventas',
  'ManageDatesBudget': '/gestion-fechas-presupuestos',
  'PartQuotation': '/cotizador-partes/',
  'PartsMaster': '/maestro-repuestos',
  'ManageColors': '/gestion-colores',
  'ClientManagement': '/administracion-cliente',
  'AdvisorManagement': '/administracion-asesor',
  'ExemptionPercentagesManagement': '/administracion-de-porcentajes-exoneracion',
  'VehiclesModels': '/ingreso-vehiculos-modelos',
  'VehicleSaleForecast': '/proyeccion-ventas-vehiculos/:salesType',
  'VehicleSaleForecastNormals': '/proyeccion-ventas-vehiculos/normales',
  'VehicleSaleForecastExonerated': '/proyeccion-ventas-vehiculos/exonerados',
  'VehiclesMaintenance': '/mantenimiento-vehiculos',
  'DailyVehiclesSalesAndStockReport': '/reporte/ventas-y-stock-diario-autos',
  'DailyVehiclesSalesAndStockWholesale': '/reporte/ventas-y-stock-diario-wholesale',
  'DailyVehiclesSalesAndStockSummary': '/reporte/resumen-ventas-y-stock-diario-autos',
  'VehiclesCertification': '/cpo',
  'SearchVehicleCertification': '/cpo/:id',
  'ListVehiclesCertification': '/list-cpo',
  'DealersAgencies': '/concesionarios/agencias',
  'DealerStockOrders': '/concesionarios/pedidos-stock',
  'DealerEmergingOrders': '/concesionarios/pedidos-emergentes',
  'DealerSpecialOrders': '/concesionarios/pedidos-especiales',
  'DealerOrdersTracking': '/concesionarios/seguimiento-pedidos',
  'DealerOrdersManagement': '/concesionarios/administracion-pedidos',
  'DealerOrdersGroupedManagement': '/concesionarios/pedidos-totales',
  'DealerOrdersImmobilized': '/concesionario/pedidos-inmovilizados',
  'DealerPossDownload': '/concesionarios/descarga-poss',
  'DealerLostSalesReport': '/concesionarios/reporte-ventas-perdidas',
  'ProviderStockOrders': '/proveedores/pedidos-stock',
  'ProviderSpecialOrders': '/proveedores/pedidos-especiales',
  'ProviderManualOrders': '/proveedores/pedidos-manuales',
  'ProviderOrdersSequenceConfig': '/proveedores/configuracion-secuencias',
  'ProviderOrdersManagement': '/proveedores/gestion-pedidos',
  'ProviderOrdersManagementDetail': '/proveedor/gestion-detalle-pedido',
  'ProviderOrdersTrackingConfig': '/proveedores/configuracion-pedidos-tracking',
  'ProviderAmountReport': '/proveedores/reporte-montos',
  'ProviderOrdersAuthorizationList': '/proveedores/autorizacion-pedidos',
  'ProviderOrdersAmountControl': '/proveedores/control-montos',
  'ProvidersImportations': '/proveedores/importaciones-en-transito',
  'VehiclesCertificationSale': '/cpo-vehicle/sale',
  'WholeSalePlanned': '/wholeSalePlanned',
  'SmByicc': '/smByicc',
  'SetsOrders': '/pedidos/combos',
  'StockAdjustmentList': '/ajuste-stock-inventario',
  'StockAdjustmentEditForm':
    '/ajuste-stock-inventario/:action/:adjustmentNumber/:jdeTypeSelected',
  'StockAdjustmentCreateForm': '/ajuste-stock-inventario/:action',
  'StockAdjustmentNewForm': '/ajuste-stock-inventario/nuevo',
  'DescriptionMantainStockAdjustment': '/ajuste-stock-mantenimiento-descripcion',
  'FileInvoices': '/facturacion-electronica',
  'TdeCalendar': '/calendario-tems',
  'MonthClose': '/cierre-mes',
  'PartsReturns': '/repuestos/devoluciones',
  'PartsReturnsDetail': '/repuestos/detalle-devoluciones',
  'MaintainSaleForecast': '/mantenimiento-proyeccion-ventas-vehiculos',
  'ServiceReportPart': '/tasa-servicio-repuestos',
  'TdeCalendarDetail': '/calendario-tems-detalle',
  'VehAudi': '/auditoria-veh',
  'BoReport': '/reporte-bo',
  'WarrantyErrorRate': '/reporte-tasa-error-garantias',
  'WarrantyErrorCodes': '/codigos-error-de-garantias',
  'WarrantyTasksCodes': '/codigos-tareas-de-garantias',
  'WarrantyTaskCodesEdit': '/codigos-tareas-de-garantias/editar/:code',
  'WarrantyTaskCodeNew': '/codigos-tareas-de-garantias/nuevo',
  'WarrantyErrorCodesEdit': '/codigos-error-de-garantias/editar/:code',
  'WarrantyErrorCodesNew': '/codigos-error-de-garantias/nuevo',
  'WarrantyReport': '/reporte-de-garantias',
  'WarrantyInsert': '/ingreso-de-garantias',
  'ExcelWarrantyInsert': '/ingreso-de-garantias-excel',
  'WarrantyQuery': '/consulta-de-garantias',
  'WarrantyInvoicing': '/consulta-facturacion-de-garantias',
  'ProcessedWarranty': '/consulta-garantias-procesadas',
  'WarrantyUpdate': '/editar-garantias/:code/:numTwcDealer/:dealerId',
  'WarrantyAdminEditForm': '/editar-garantias-admin/:code/:numTwcDealer/:dealerId',
  'ItemBudget': '/presupuesto-partes',
  'SearchCombosVehicles': '/buscar-combos-de-vehiculos',
  'InvoicesList': '/listado-de-facturas',
  'MaintainFormsServices': '/mantenimiento-de-formularios',
  'CampaignList': '/mantenimiento-de-campanas',
  'CreateCampaign': '/ingreso-de-campanas',
  'EditCampaign': '/editar-campana/:id',
  'ViewCampaign': '/ver-campana/:id',
  'WarrantyCampaignsReport': '/reporte/garantias-de-campana',
  'CampaignPartsOrders': '/pedidos-campana/:id/partes',
  'CampaignPartOrder': '/pedidos-campana/:id/partes/:partno',
  'CampaignAndChassisQuery': '/consulta/campana-y-chasis',
  'ListVehiclesWaitHappy': '/listado-vehiculos-espera-feliz',
  'DealerWaitHappy': '/ingreso-dealer-espera-feliz/:id',
  'AgencyWaitHappy': '/ingreso-agencia-espera-feliz/:id',
  'TimeMarked': '/marcado-tiempos',
  'LubricantsInvoicing': '/lubricantes/facturacion',
  'PrioritizationIndices': '/reporte/indices-priorizacion',
  'LogisticIndices': '/reporte/indices-logistica',
  'TechniciansGroups': '/grupos-tecnicos',
  'Technicians': '/tecnicos',
  'KanbanLogistics': '/kanban-logistica',
  'VehiclesAvailability': '/accesorios/disponibilidad-vehiculos',
  'VehiclesHistory': '/historial-vehiculos',
  'AccessoriesInvoicing': '/accesorios/facturacion',
  'ReportCombos': '/reporte-combos',
  'CodeWithoutLabels': '/codigos-sin-etiquetas',
  'AnticipatedInvoiceVehiclesSelection': '/facturacion-anticipada/seleccion-vehiculos',
  'AnticipatedInvoiceVehiclesValidation': '/facturacion-anticipada/validacion-vehiculos',
  'DispatchOrdersList': '/ordenes-despacho',
  'DispatchOrdersAdd': '/ordenes-despacho/nuevo',
  'DispatchOrdersEdit': '/ordenes-despacho/editar/:code',
  'DispatchOrdersApprovals': '/ordenes-despacho/aprobaciones',
  'DevicesOrders': '/dispositivos/pedidos',
  'ManageOrders': '/vehiculos/administracion-pedidos',
  'CreateManageOrders': '/vehiculos/administracion-pedidos/crear-pedido',
  'ParamsManageOrders': '/vehiculos/administracion-pedidos/parametros',
  'ShowManageOrder': '/vehiculos/administracion-pedidos/order/:id',
  'RequestsInstallationDevice': '/dispositivos/solicitudes',
  'PartsImportsTrackingDashboard': '/importaciones/repuestos/tracking',
  'VehiclesInventory': '/vehiculos/administracion-inventario',
  'VehiclesInventoryTable': '/vehiculos/administracion-inventario/:master',
  'FloatingInventorySummary': '/vehiculos/inventario-flotante-resumen',
  'FloatingInventory': '/vehiculos/inventario-flotante',
  'FloatingInventoryAudit': '/vehiculos/auditorias-inventario-flotante',
  'FloatingInventoryReport': '/vehiculos/reporte-inventario-flotante',
  'CustomerTracking': '/vehiculos/seguimiento-cliente',
  'MailGroupList': '/listado-grupos-de-correo',
  'MailGroupNew': '/grupo-de-correo/nuevo',
  'MailGroupEdit': '/grupo-de-correo/editar/:grupo',
  'BulletinService': '/boletines/servicio/nuevo',
  'BulletinServiceEdit': '/boletines/servicio/editar/:id',
  'BulletinTMC': '/boletines/TMC/nuevo',
  'BulletinTMCEdit': '/boletines/TMC/editar/:id',
  'BulletinQuery': '/consulta/boletines',
  'AccessoriesRequestManagement': '/facturacion-anticipada/pedidos-accesorios',
  'AccessoriesRequestSummary': '/facturacion-anticipada/resumen-accesorios',
  'CombosList': '/combos',
  'ComboEdit': '/combos/editar/:code',
  'ComboCreate': '/combos/crear',
  'CombosByKatashikies': '/combos/katashikis',
  'TransportistManagement': '/transportistas',
  'AgenciesManagement': '/agencias',
  'LogisticModels': '/logistica/modelos',
  'LogisticTasks': '/logistica/tareas',
  'VehiclesPriorizationDates': '/priorizacion-actualizar-fechas',
  'VehiclesPriorizationDailyQuota': '/priorizacion-administrar-cupo-diario',
  'DevicesStock': '/dispositivos/stock',
  'CommercialUsers': '/comercial/usuarios',
  'VehiclesPriceColorLoad': '/vehiculos/cargar-precios',
  'AccountState': '/estado-cuenta',
  'WtsCatalogs': '/wts/configuracion/catalogos',
  'WtsEmployees': '/wts/participantes',
  'WtsEmployeesGestor': '/wts/participantesGestor',
  'WtsCourses': '/wts/configuracion/cursos',
  'WtsCourseNew': '/wts/configuracion/cursos/nuevo',
  'WtsCourseEdit': '/wts/configuracion/cursos/editar/:courseId',
  'WtsCalendario': '/wts/calendario',
  'WtsRegistroTrabajoAgencias': '/wts/registro-trabajo-agencias',
  'ReportPartsSalesJapan': '/reporte-ventas-partes-japon',
  'PartsLocationDashboard': '/parts-location-dashboard',
  'DealerOrdersEtaManagement': '/proveedores/administracion-eta',
};
